import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { merchantsService } from '../../../shared/api/services/merchants.service'
import type { MerchantFilters } from '../../../shared/api/services/merchants.service'

export const useMerchants = () => {
    const [searchText, setSearchText] = useState('')
    const [statusFilter, setStatusFilter] = useState<string>('all')
    const [kycFilter, setKycFilter] = useState<string>('all')
    const [sourceFilter, setSourceFilter] = useState<string>('all')
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)

    const filters: MerchantFilters = {
        page,
        per_page: pageSize,
        search: searchText || undefined,
        status: statusFilter !== 'all' ? statusFilter : undefined,
        kyc_status: kycFilter !== 'all' ? kycFilter : undefined,
        source: sourceFilter !== 'all' ? sourceFilter : undefined,
    }

    const { data: response, isLoading, isFetching, error, refetch } = useQuery({
        queryKey: ['merchants', filters],
        queryFn: () => merchantsService.getMerchants(filters),
        placeholderData: (previousData) => previousData,
    })

    return {
        merchants: response?.data || [],
        totalMerchants: response?.meta.total || 0,
        searchText,
        setSearchText,
        statusFilter,
        setStatusFilter,
        kycFilter,
        setKycFilter,
        sourceFilter,
        setSourceFilter,
        page,
        setPage,
        pageSize,
        setPageSize,
        isLoading,
        isFetching,
        error,
        refetch
    }
}
